import type { PeopleFilters } from '../types/people'
import { usePeopleSearch } from './usePeopleSearch'

export function usePeople(
  query: string,
  opts?: { sort?: 'trending' | 'newest'; verifiedOnly?: boolean; limit?: number; filters?: Partial<PeopleFilters> }
) {
  const { items, error, loading, debouncedQuery, filterSignature, lastFetchUrl, lastSuccessAt } = usePeopleSearch(query, opts)
  return { items, error, loading, debouncedQuery, filterSignature, lastFetchUrl, lastSuccessAt }
}
